import {ICredencial} from "../api/ApiCredencial";
import {useEffect, useState} from "react";
import {SaldoColaborador} from "../api/SaldoColaborador";
import * as React from "react";
import {Box, Button} from "@mui/material";
import {BsEye, BsEyeSlash, BsThreeDots} from "react-icons/bs";
import ExtratoTable from "./ExtratoTable";

function SaldoCard({credencial}: { credencial: ICredencial }) {
    const [dados, setDados] = useState({
        saldo: 0,
        limitecredito: 0,
        acumulado: 0
    });
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState(false);


    const mat = credencial.matricula.replace(/-/g, '');
    const categoria = credencial.categoria;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await SaldoColaborador.getSaldo(mat);
                const data = await response;
                setDados(data);
                setCarregando(false);
            } catch (error) {
                setErro(true);
                setCarregando(false);
            }
        };

        fetchData();
    }, [credencial]);

    const categoriasIgnoradas = ['SERVIDOR', 'SENAC', 'FECOMERCIO'];

    if (!categoriasIgnoradas.includes(categoria.nome)) {
        return null; // Retorna null se a categoria não for uma das categoriasIgnoradas
    }

    return (
        <>
            {carregando ? (
                <p>Carregando...</p>
            ) : erro ? (
                <SaldoDivShowHide limite={0} acumulado={0} saldo={0} />
            ) : (
                <SaldoDivShowHide limite={dados.limitecredito} acumulado={dados.acumulado} saldo={dados.saldo} />
            )}
        </>
    );
}

function SaldoDivShowHide({limite, acumulado, saldo}: { limite: Number, acumulado: Number, saldo: Number }) {
    const [visible, setVisible] = React.useState(true);
    return (
        <Box style={{ width: '295px', marginBottom: '0.5rem', display: "flex"}}>
            <Box style={{ flex: "1 1 97%"}}>
                <div style={{fontWeight: 'bold', fontSize: 'larger'}}>
                    {visible ? <BsThreeDots/> : saldo.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}
                </div>
                <div style={{fontWeight: 'bold', fontSize: '0.90rem'}}>Saldo Restante</div>
            </Box>
            <Box style={{ flex: "1 1 3%"}}>
                <Button size="large" fullWidth={true} variant="contained"
                        onClick={() => setVisible(!visible)}>
                    {visible ?  <BsEyeSlash /> : <BsEye />}
                </Button>
            </Box>
        </Box>
    );
}

export default SaldoCard;